class ShareButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (!this.button) return;
    if (!navigator.share) return;

    this.options = {
      title: document.title,
    };

    if (this.dataset.context == "product") {
      this.options["text"] = Theme.translations.product_share.replace(
        "[share_url]",
        this.dataset.url
      );
    } else {
      this.options["url"] = this.dataset.url;
    }

    this.classList.remove("hidden");

    this.button.addEventListener("click", async () => {
      try {
        await navigator.share(this.options);
      } catch (error) {
        console.error("Error on sharing page:", error);
      }
    });
  }
}
customElements.define("share-button", ShareButton);
